import * as React from "react";
import { styled, Theme, CSSObject, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Badge, Grid, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import DashboardLogo from "./../../assets/images/dashboard.png";
import CompanyLogo from "./../../assets/svgIcons/company-logo.svg";
import Smalllogo from "./../../assets/svgIcons/company-sidebar-logo.svg";
import HelpOutlineIcon from "./../../assets/svgIcons/help.svg";
import notificationsIcon from "./../../assets/svgIcons/bell.svg";
import userd from "./../../assets/svgIcons/profile.svg";
import logout from "./../../assets/svgIcons/logout.svg";
import notificationsServices from "../../services/api/service/notificationService";
import {
  notificationSelector,
  setNotification,
  setLoadingNotification,
  setUnreadCount,
  setNotificationtype,
} from "../../services/redux/slices/notificationSlice";
import { authSelector } from "../../services/redux/slices/authSlice";
import ProfileAvatar from "../common/ProfileAvatar";
import { ROUTES } from "../../routes/routerConfig";
import { resetDisbursementButtonValue } from "../../services/redux/slices/disbursementButtonSlice";
import { setDocumentDiscardModal } from "../../services/redux/slices/documentFormSlice";
import { encrypt } from "../../utils/crypto";
import { setSelectedIndex } from "../../services/redux/slices/tabsSlice";
import GridViewIcon from "@mui/icons-material/GridView";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import SideNavBarMenuMobile from "./mobile/SideNavBarMenuMobile";
import { useSelector, useDispatch } from "react-redux";
import { persistor, RootState } from "../../services/redux/store";

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}
interface SidNavBarMenuOption {
  path: string;
  label: string;
  icon: string;
  QuickLinks?: { path: string; label: string }[];
}
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}
export default function MiniDrawer() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { userProfile } = useSelector(authSelector);
  const { unreadCount } = useSelector(notificationSelector);
  const [open, setOpen] = React.useState(false);
  const [display, setDisplay] = React.useState("none");
  const [hoveredQuickLinks, setHoveredQuickLinks] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const isProfileMenuOpen = Boolean(anchorEl);
  const [selectedItem, setSelectedItem] = React.useState("Flexi Term Loan");
  const selectedFormType = useSelector(
    (state: RootState) => state?.documentFormSlice
  );
  const businessType = useSelector(
    (state: RootState) => state?.auth?.businessType?.name
  );
  const businessTypeId = useSelector(
    (state: RootState) => state?.auth?.businessType?.id
  );
  dispatch(setNotificationtype("Term Loan"));
  const notificationType = useSelector(
    (state: RootState) => state?.notification?.notificationType
  );
  const loanCategoryData: any = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );
  const selectedLoanNumber = useSelector(
    (state: RootState) => state.dashboardData.selectedLoanNumber
  );
  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );

  const termLoanData = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );

  const tabType = useSelector((state: RootState) => state.tabs.tabType);

  const handleDrawerOpen = () => {
    setOpen(true);
    setDisplay("block");
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setDisplay("none");
  };
  const handleProfileMenuOpen = (event: { currentTarget: any }) => {
    setAnchorEl(event.currentTarget);
  };
  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogOutMenu = async () => {
    if (
      selectedFormType?.formType === "continue" &&
      selectedFormType?.isNewData
    ) {
      dispatch(setDocumentDiscardModal());
    } else {
      dispatch({ type: 'USER_LOGOUT' });  // after logout api calls and navigation was working, so this is the fix for that 
      window?.ReactNativeWebView?.postMessage(
        JSON.stringify({ type: "LOGOUT" })
      );
      localStorage.removeItem("selectedIndex");
      localStorage.removeItem("payType");
      // dispatch({ type: PURGE, key: 'root' });
      handleProfileMenuClose();
      sessionStorage?.clear();
      await persistor.purge(); // clearing redux store
      window.location.href = "/login";
    }
  };
  
  /**
   * Handles the click event for a list item in the side navigation bar.
   *
   * @param text - The text of the clicked list item.
   *
   * If the selected form type is "continue" and it has new data, it dispatches an action to show the document discard modal.
   * Otherwise, it resets the disbursement button value, sets the selected item, and navigates to the dashboard.
   */
  const handleListItemClick = (data: any) => {
    setOpen(false);
    setIsHovered(true);
    dispatch(resetDisbursementButtonValue());
    let newIndex = 0;
    let tabTypeParam = "";
    if (data?.path === "") {
      if (data?.label === "Disbursement") {
        const matchVal = dashboardDataSet?.find(
          (data: any) => data?.lanNumber === selectedLoanNumber
        );
        if (
          matchVal?.isExistDisbursementAllowdLoan === false ||
          matchVal?.status != "A"
        ) {
          newIndex = 0;
          dispatch(setSelectedIndex(0));
          dispatch(
            setStatusPopup({
              status: "no access",
              // message: `Disbursement requests are not permitted for this loan.`,
              message:
                "Disbursement requests are currently unavailable for this loan",
            })
          );
        } else {
          newIndex = 1;
          dispatch(setSelectedIndex(1));
        }
      } else if (data?.label === "Payment") {
        if (termLoanData?.TermLoan?.length > 0) {
          var matchVal = dashboardDataSet?.find(
            (data: any) => data?.lanNumber === selectedLoanNumber
          );
          if (matchVal?.status != "A") {
            newIndex = 0;
            dispatch(setSelectedIndex(0));
            dispatch(
              setStatusPopup({
                status: "no access",
                // message: `Disbursement requests are not permitted for this loan.`,
                message:
                  "Payment requests are currently unavailable for this loan",
              })
            );
          } else {
            newIndex = 2;
            dispatch(setSelectedIndex(2));
          }
        } else if (termLoanData?.Flexi?.length > 0) {
          var matchVal = dashboardDataSet?.find(
            (data: any) => data?.loanAccountNumber === selectedLoanNumber
          );
          if (matchVal?.statusOfLoan != "A") {
            newIndex = 2;
            dispatch(setSelectedIndex(2));
            dispatch(
              setStatusPopup({
                status: "no access",
                // message: `Disbursement requests are not permitted for this loan.`,
                message:
                  "Payment requests are currently unavailable for this loan",
              })
            );
          } else {
            newIndex = 2;
            dispatch(setSelectedIndex(2));
          }
        }
      } else if (data?.label === "Documents") {
        newIndex = 3;
        dispatch(setSelectedIndex(3));
      } else if (data?.label === "History") {
        newIndex = 4;
        dispatch(setSelectedIndex(4));
      } else if (data?.label === "Withdraw") {
        newIndex = 1;
        dispatch(setSelectedIndex(1));
      }
    } else {
      setSelectedItem(data?.path);
      newIndex = 0;
      dispatch(setSelectedIndex(0));
    }

    if (tabType === "Flexi Term Loan") {
      const tabTypeByIndex: Record<number, string> = {
        0: "accountsummary",
        1: "withraw",
        2: "payment",
        3: "statements",
      };
      tabTypeParam = tabTypeByIndex[newIndex] || "accountsummary";
    }

    navigate(
      tabTypeParam ? `/dashboard?tabType=${tabTypeParam}` : `/dashboard`,
      { replace: true }
    );
  };

  // notifications Drop Down
  const [anchorNotifyEl, setAnchorNotifyEl] =
    React.useState<HTMLButtonElement | null>(null);

  const handleBellClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorNotifyEl(event.currentTarget);
  };

  const handleBellClose = () => {
    setAnchorNotifyEl(null);
  };

  const openNotify = Boolean(anchorNotifyEl);

  // notifications Drop Down

  const drawerWidth = 200;
  const drawerWidthNew = 225;
  const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
    backgroundColor: "#1CB1B1",
    color: "#fff",
    padding: "5px",
  });

  const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    backgroundColor: "#1CB1B1",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("xs")]: {
      width: `calc(${theme.spacing(0)} + 0px)`,
      backgroundColor: "#fff",
      //padding: "10px",
    },
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(8)} + 10px)`,
      padding: "10px",
      backgroundColor: "#1CB1B1",
    },
  });

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  }));
  const SmallLogo = styled("img")({
    width: 47,
    height: "auto",
  });

  const BigLogo = styled("img")({
    width: "118px",
    height: "auto",
  });

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })<AppBarProps>(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),

    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }));

  const getNotificationsList = async () => {
    if (!notificationType || notificationType.trim() === "") {
      return;
    }
    dispatch(setLoadingNotification(true));
    try {
      const bodyObj: any = {};
      let cifNumber = userProfile?.cifNumber;
      let cifEntity = userProfile?.cifEntity;
      if (
        loanCategoryData?.Flexi?.length > 0 &&
        loanCategoryData?.TermLoan?.length > 0
      ) {
        if (businessType == "retail" && notificationType == "Term Loan") {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.TermLoan[0]?.loanCategoryId
          );
        } else if (
          businessType == "flexi" &&
          notificationType == "Flexi Term Loan"
        ) {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        } else if (
          businessType == "retail" &&
          notificationType == "Flexi Term Loan"
        ) {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        } else {
          bodyObj.cifEntity = cifEntity;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        }
      } else {
        if (businessType == "retail" && notificationType == "Term Loan") {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.TermLoan[0]?.loanCategoryId
          );
        } else if (
          businessType == "retail" &&
          notificationType == "Flexi Term Loan"
        ) {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        } else if (
          businessType == "entity" &&
          loanCategoryData?.TermLoan?.length > 0
        ) {
          bodyObj.cifNumber = cifNumber;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.TermLoan[0]?.loanCategoryId
          );
        } else {
          //bodyObj.cifEntity = cifEntity;
          bodyObj.businessType = encrypt(businessTypeId);
          bodyObj.loanCategory = encrypt(
            loanCategoryData?.Flexi[0]?.loanCategoryId
          );
        }
      }
      const res = await notificationsServices.getNotifications(bodyObj);

      if (res?.status == 200 && res?.data?.data) {
        const notificationsList = res?.data?.data?.filter(
          (n: any) => n.readStatus === false
        );
        const unreadCount = res?.data?.pagination?.unreadNotificationsCounts;
        dispatch(setNotification(notificationsList));
        dispatch(setUnreadCount(unreadCount));
      }
    } catch (error) {
      console.error("get notifications API error::", error);
    }
    dispatch(setLoadingNotification(false));
  };

  React.useEffect(() => {
    if (openNotify) {
      getNotificationsList();
    }
  }, [openNotify, notificationType, loanCategoryData]);

  React.useEffect(() => {
    if (!openNotify) {
      getNotificationsList();
    }
  }, [notificationType, loanCategoryData]);

  React.useEffect(() => {
    function isMobileDevice(): boolean {
      // Regular expression to check for mobile user agents
      const mobileRegex =
        /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

      // Check if the user-agent string matches the mobile regex
      return mobileRegex.test(navigator.userAgent);
    }

    // Example usage:
    if (isMobileDevice()) {
      console.log("You are on a mobile device.");
      setOpen(false);
    } else {
      console.log("You are on a desktop ");
      setOpen(false);
    }
  }, []);

  const quickLinkClick = (e: any, path: any) => {
    e.preventDefault();
    window.open(path, "_blank");
  };
  const [isHovered, setIsHovered] = React.useState(true);
  const handleMouseEnter = (label: any) => {
    setOpen(true);
    setIsHovered(false);
    if (label === "QuickLinks") {
      setHoveredQuickLinks(true);
    }
  };
  const handleMouseLeave = (label: any) => {
    //setOpen(false);
    if (label === "QuickLinks") {
      setHoveredQuickLinks(false);
    }
  };
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box>
      {/* <CssBaseline /> */}
      <Grid container>
        <Grid item xs={false} sm={2} md={2} lg={2}>
          <Drawer
            variant="permanent"
            open={open}
            sx={{
              "& .MuiDrawer-paper": {
                background: "#FFFFFF",
                color: "#000", // Optional: text color
              },
            }}
          >
            <DrawerHeader sx={{ textAlign: "center", padding: "0px 0px" }}>
              {/* <IconButton sx={{ padding: "0px" }}> */}
              {open ? (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  sx={{ flexDirection: "row", gap: "24px" }}
                >
                  <BigLogo src={CompanyLogo} alt="Logo" />
                  <Box>
                    <MenuIcon
                      style={{ color: "#666666", cursor: "pointer" }}
                      onClick={() => {
                        setOpen(false);
                        setIsHovered(true);
                      }}
                    />
                  </Box>
                </Box>
              ) : (
                <SmallLogo
                  src={Smalllogo}
                  alt="Small Logo"
                  onClick={() => {
                    setOpen(true);
                    setIsHovered(false);
                  }}
                  sx={{ cursor: "pointer" }}
                />
              )}
              {/* </IconButton> */}
            </DrawerHeader>
            <List className="sideNavBarText">
              {termLoanData?.TermLoan.length > 0 &&
                (businessType == "retail" ||
                  businessType == "entity" ||
                  tabType === "Term Loan") && (
                  <>
                    {ROUTES?.SidNavBarMenuOptions?.map((link, index) => (
                      <ListItem
                        key={index}
                        disablePadding
                        sx={{
                          display: "block",
                          height: 57,
                          marginBottom: "10px",
                        }}
                      >
                        <ListItemButton
                          selected={selectedItem === link.label}
                          onClick={() => handleListItemClick(link)}
                          onMouseEnter={() => handleMouseEnter(link.label)}
                          onMouseLeave={() => handleMouseLeave(link.label)}
                          sx={{
                            height: 54,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            backgroundColor:
                              selectedItem === link.label ? "red" : "initial",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              mr: open ? 3 : "auto",
                              justifyContent: "center",
                              height: 54,
                              marginRight: "0px",
                            }}
                          >
                            {link?.path !== "" ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: 53,
                                  height: 50,
                                }}
                              >
                                {isHovered ? (
                                  <img
                                    src={DashboardLogo}
                                    alt="Hover Logo"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  <GridViewIcon
                                    sx={{
                                      fontSize: 20,
                                      color: "gray",
                                    }}
                                  />
                                )}
                              </Box>
                            ) : (
                              <img
                                src={link?.icon}
                                alt="icon"
                                style={{
                                  display: "block",
                                  width: "56px",
                                  height: "41px",
                                  marginTop: "6px",
                                  objectFit: "contain",
                                }}
                              />
                            )}
                          </ListItemIcon>
                          <ListItemText
                            primary={link.label}
                            sx={{ opacity: open ? 1 : 0 }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </>
                )}

              {termLoanData?.Flexi.length > 0 &&
                (businessType == "flexi" || tabType === "Flexi Term Loan") && (
                  <>
                    {ROUTES?.SideNavBarMenuFlexiOptions?.map((link, index) => (
                      <ListItem
                        key={index}
                        disablePadding
                        sx={{
                          display: "block",
                          height: 57,
                          marginBottom: "10px",
                        }}
                      >
                        <ListItemButton
                          selected={selectedItem === link.label}
                          onClick={() => handleListItemClick(link)}
                          onMouseEnter={() => handleMouseEnter(link.label)}
                          onMouseLeave={() => handleMouseLeave(link.label)}
                          sx={{
                            height: 54,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            backgroundColor:
                              selectedItem === link.label ? "red" : "initial",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              mr: open ? 3 : "auto",
                              justifyContent: "center",
                              height: 54,
                              marginRight: "0px",
                            }}
                          >
                            {link?.path !== "" ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: 53,
                                  height: 50,
                                }}
                              >
                                {isHovered ? (
                                  <img
                                    src={DashboardLogo}
                                    alt="Hover Logo"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                ) : (
                                  <GridViewIcon
                                    sx={{
                                      fontSize: 20,
                                      color: "gray",
                                    }}
                                  />
                                )}
                              </Box>
                            ) : (
                              <img
                                src={link?.icon}
                                alt="icon"
                                style={{
                                  display: "block",
                                  width: "56px",
                                  height: "41px",
                                  marginTop: "6px",
                                  objectFit: "contain",
                                }}
                              />
                            )}
                          </ListItemIcon>
                          <ListItemText
                            primary={link.label}
                            sx={{ opacity: open ? 1 : 0 }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </>
                )}
            </List>

            {!isXsOrSm && (
              <div style={{ position: "fixed", bottom: "0px" }}>
                <Box>
                  <ListItemButton
                    selected={selectedItem === ROUTES.QuickLinks.label}
                    onClick={() => handleListItemClick(ROUTES.QuickLinks)}
                    onMouseEnter={() =>
                      handleMouseEnter(ROUTES.QuickLinks.label)
                    }
                    onMouseLeave={() =>
                      handleMouseLeave(ROUTES.QuickLinks.label)
                    }
                  >
                    <ListItemIcon>
                      <img src={HelpOutlineIcon} alt="quick-help" />
                      {/* <GridViewIcon /> */}
                    </ListItemIcon>

                    {open && (
                      <ListItemText
                        primary={ROUTES?.QuickLinks?.label}
                        sx={{ opacity: 1, color: "gray" }}
                      />
                    )}
                  </ListItemButton>
                  {hoveredQuickLinks && ROUTES?.QuickLinks?.QuickLinks && (
                    <Menu
                      anchorEl={document.getElementById("quickLinks-anchor")}
                      open={hoveredQuickLinks}
                      onClose={() => setHoveredQuickLinks(false)}
                      MenuListProps={{
                        onMouseLeave: () => setHoveredQuickLinks(false),
                      }}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    >
                      {ROUTES.QuickLinks?.QuickLinks?.map(
                        (quickLink, index) => (
                          <MenuItem
                            key={index}
                            onClick={() =>
                              (quickLink as { path: string; label: string; isInternal?: boolean }).isInternal
                                ? navigate(quickLink.path)
                                : window.open(quickLink.path, "_blank")
                            }
                          >
                            <span className="gray"> {quickLink.label}</span>
                          </MenuItem>
                        )
                      )}
                    </Menu>
                  )}
                </Box>
              </div>
            )}
            {/* <aside>
              <List
                className="quick-link"
                sx={{ display: { xs: display, sm: display, md: "block" } }}
              > */}
            {/* <ListItem className="quick-text">Quick Links</ListItem>
                <p className="quick-text-divider" />
                <List
                  sx={{ marginTop: "auto", marginBottom: "0px" }}
                  className="quick-text-inner"
                >
                  {ROUTES?.QuickLinks?.map((link) => (
                    <ListItem
                      key={link.label}
                      disablePadding
                      sx={{ display: "block" }}
                      className="quick-text-inner-li"
                    >
                      {handleNavigateLink(link)}
                    </ListItem>
                  ))}
                </List> */}
            {/* <List className="quick-text-inner">
                  {ROUTES.Dashboard.links.map((link) => (
                    <ListItem
                      key={link.label}
                      disablePadding
                      sx={{ display: "block" }}
                    >
                      <ListItemButton
                        selected={selectedItem === link.label}
                        style={{ padding: "0px 0px 0px 8px" }}
                        onClick={() => {
                          setSelectedItem(link.label);
                          handleListItemClick(link.path);
                        }}
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                          backgroundColor:
                            selectedItem === link.label ? "red" : "initial",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <img src={link.icon} alt={link.label} />
                        </ListItemIcon>
                        <ListItemText
                          primary={link.label}
                          sx={{ opacity: open ? 1 : 0 }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List> */}
            {/* </List>
            </aside> */}
          </Drawer>
        </Grid>

        <Grid item xs={12} sm={10} md={10} lg={10}>
          <Grid container spacing={2} sx={{ padding: "10px" }}>
            {!isXsOrSm ? (
              <AppBar
                sx={{
                  backgroundColor: "white",
                  height: "80px",
                  marginTop: "12px",
                  marginRight: "1%",
                  borderRadius: "6px",
                  paddingRight: "0px !important",
                  boxShadow: "0px 2px 4px 0px rgba(165, 163, 174, 0.3)",
                  width: open
                    ? `calc(100% - ${drawerWidthNew}px)`
                    : `calc(100% - 100px)`,
                  ml: open ? `${drawerWidthNew}px` : 0,
                  transition: "all 0.3s ease",
                }}
              >
                <Toolbar sx={{ marginTop: "10px", height: "48px" }}>
                  <Box>
                    <Typography
                      variant="h6"
                      noWrap
                      component="div"
                      sx={{
                        display: {
                          xs: "block",
                          sm: "block",
                          md: "block",
                          color: "rgba(39, 87, 92, 1)",
                          fontWeight: "700",
                          fontSize: "18px",
                          lineHeight: "25px",
                        },
                      }}
                    >
                      Welcome back {userProfile?.name} 👋
                    </Typography>
                    <Typography
                      variant="h5"
                      noWrap
                      component="div"
                      sx={{
                        display: {
                          xs: "block",
                          sm: "block",
                          md: "block",
                          color: "rgba(112, 117, 121, 1)",
                          fontWeight: "500",
                          fontSize: "15px",
                          lineHeight: "22px",
                        },
                      }}
                    >
                      Monitor all your loan applications and loan accounts from here
                    </Typography>
                  </Box>

                  {/* <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={open ? handleDrawerClose : handleDrawerOpen}
                  sx={{
                    mr: open ? 30 : 4,
                    display: { xs: "block", sm: "block", md: "none" },
                  }}
                >
                  {open ? (
                    <MenuIcon style={{ marginLeft: "260px", color: "#666666" }} />
                  ) : (
                    <MenuIcon style={{ color: "#666666" }} />
                  )}
                </IconButton> */}
                  {/* <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{ display: { xs: "none", sm: "block", md: "block" } }}
                >
                  {open ? (
                    <MenuIcon
                      onClick={open ? handleDrawerClose : handleDrawerOpen}
                      style={{ display: "none", color: "#666666" }}
                    />
                  ) : (
                    <MenuIcon
                      style={{ color: "#666666" }}
                      onClick={open ? handleDrawerClose : handleDrawerOpen}
                    />
                  )}
                </Typography> */}
                  <Box sx={{ flexGrow: 1 }} />

                  {isXsOrSm && <IconButton
                    onClick={handleBellClick}
                    size="large"
                    aria-label="show 5 new notifications"
                    sx={{
                      "&:hover": {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                      },
                    }}
                  >
                    <Badge badgeContent={unreadCount} color="error">
                      <img src={notificationsIcon} alt="Notifications " />
                    </Badge>
                  </IconButton>}
                  <IconButton
                    sx={{
                      paddingLeft: "25px",
                      gap: 1,
                      "&:hover": {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                      },
                    }}
                    size="large"
                    aria-label="account of current user"
                    aria-controls="profile-menu"
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                  >
                    <ProfileAvatar
                      name={userProfile?.name}
                      src={userProfile?.profileImage}
                      size={40}
                    />
                    {/* <span style={{ fontSize: "11px", textAlign: "left" }}>
                    <Typography
                      sx={{ display: { xs: "none", sm: "block" } }}
                      style={{
                        fontWeight: "500",
                        color: "#0A0A0A",
                        paddingRight: "30px",
                        fontSize: "16px",
                        textTransform: "capitalize",
                      }}
                    >
                      {userProfile?.name}
                      <img
                        src={down_arrow}
                        alt="down arrow"
                        style={{ marginLeft: "10px" }}
                      />
                    </Typography>
                  </span> */}
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={isProfileMenuOpen}
                    onClose={handleProfileMenuClose}
                    className="profile-container"
                  >
                    <MenuItem
                      onClick={() => {
                        if (
                          selectedFormType?.formType === "continue" &&
                          selectedFormType?.isNewData
                        ) {
                          dispatch(setDocumentDiscardModal());
                        } else {
                          navigate("/profile");
                          handleProfileMenuClose();
                        }
                      }}
                    >
                      <img src={userd} alt="user" /> Profile
                    </MenuItem>
                    <MenuItem onClick={handleLogOutMenu}>
                      <img src={logout} alt="log out" /> Logout
                    </MenuItem>
                  </Menu>
                </Toolbar>
              </AppBar>
            ) : (
              <>
                <AppBar
                  sx={{
                    background: "#F8F7FA",
                    marginTop: "20px",
                    boxShadow: "none",
                    padding: "0px 20px",
                  }}
                >
                  <SideNavBarMenuMobile />
                </AppBar>
              </>
            )}
          </Grid>

          {/* notification */}
          {/* <NotificationsDropDown
            open={openNotify}
            anchorEl={anchorNotifyEl}
            handleClose={handleBellClose}
          /> */}
          {/* notification */}
        </Grid>
      </Grid>
      {/* 

      */}
    </Box>
  );
}